export default {
  "home.jpg": require("@/assets/images/richHtml/intelligentPetFeeder/screens/home.jpg"),
  "device-basic.jpg": require("@/assets/images/richHtml/intelligentPetFeeder/screens/device-basic.jpg"),
  "desiccant-settings.jpg": require("@/assets/images/richHtml/intelligentPetFeeder/screens/desiccant-settings.jpg"),
  "share-family.jpg": require("@/assets/images/richHtml/intelligentPetFeeder/screens/share-family.jpg"),
};
